












import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseMixin from '@/mixins/base';

@Component({
  mixins: [BaseMixin]
})
export default class DataTableWrapper extends Mixins(BaseMixin) {
  @Prop({ default: false })
  public readonly darkHeader!: boolean;
}
